import { placesFwkRootComponentMountedAction } from "places-fwk-actions";
import { orchestrator } from "satcheljs";
import { PlacesBuildingSwitchE2EComplete } from "../placesBuildingPickerSwitchE2E";

orchestrator(placesFwkRootComponentMountedAction, ({ rootComponentName }) => {
    if (rootComponentName === "PlacesBuildingCardContent") {
        PlacesBuildingSwitchE2EComplete(true);
    }
});
